// /*
//  * Image lazyLoad
//  * @parameter images = $('img')
//  * @parameter opt
//  *            offset: int预加载图片的高度
//  */
const $ = require('jquery');
// const lazyAttr = 'lazy-src';

// const LazyLoad = (images, opt) => {
//     opt = opt || {};
//     let offset = opt.offset || 0;
//     let els = images.get().filter(function(el) {
//         return !!$(el).attr(lazyAttr);
//     }); // ==> array
//     let len = els.length;
//     let action = function() {
//         let currentTop = $(window).scrollTop()
//         let winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
//         let currentDown = $(window).scrollTop() + winHeight + offset;
//         for (let i = 0, l = els.length; i < l; i++) {
//             let el = $(els[i]);
//             if (el.attr(lazyAttr)) {
//                 let elTop = $(el).offset().top;
//                 if (currentDown >= elTop && elTop >= currentTop) {
//                     el.attr('src', el.attr(lazyAttr)).removeAttr(lazyAttr);
//                     len--;
//                 }
//             }
//         }
//         if (len <= 0) {
//             if (window.removeEventListener) {
//                 window.removeEventListener('scroll', action, false);
//             } else {
//                 window.attachEvent('scroll', action);
//             }
//         }
//     };
//     if (window.removeEventListener) {
//         window.addEventListener('load', action, false);
//         window.addEventListener('scroll', action, false);
//     } else {
//         window.attachEvent('load', action, false);
//         window.attachEvent('scroll', action, false);
//     }
//     action();
// };
var LazyLoad = function(obj) {
    this.item = obj.item; // 需要被懒加载的图片
    this.attr = obj.attr || 'lazy-src'; // 真实的图片路径
    this.contain = obj.contain || window; // 滚动的容器
    this.callBack = obj.callBack || null;
    this.handle();
};
LazyLoad.prototype._cache = function() {
    var _this = this;
    var item = _this.item;
    var cache = [];
    for (var i = 0, l = item.length; i < l; i++) {
        var nodeTag = item[i].nodeName.toLowerCase();
        var url = item[i].getAttribute(_this.attr);
        var data = {
            item: item,
            nodeTag: nodeTag,
            url: url
        };
        cache.push(data);
    }
    return cache;
};

LazyLoad.prototype._addEvent = function(obj, ev, actionResponse) {
    if (obj.addEventListener) {
        obj.addEventListener(ev, actionResponse, false);
    } else {
        obj.attachEvent('on' + ev, actionResponse);
    }
};

LazyLoad.prototype.handle = function() {
    var _this = this;
    var thisItem = _this.item;
    var datas = this._cache();
    var scrolling = null;
    // 滚动开始至结束的事件
    _this.events = {
        end: function() {
            clearTimeout(scrolling);
        },
        start: function() {
            scrolling = setTimeout(function() {
                _this.events.scrollFn();
            }, 300);
        },
        scrollFn: function() {
            datas.forEach = function(fn, context) {
                for (var k = 0, length = this.length; k < length; k++) {
                    if (typeof fn === 'function' && Object.prototype.hasOwnProperty.call(this, k)) {
                        fn.call(context, this[k], k, this);
                    }
                }
            }
            datas.forEach(function(value, index, array) {
                var items = datas[index].item;
                var src = datas[index].url;
                var tag = datas[index].nodeTag;
                // 循环懒需要加载的元素
                var url = items[index].getAttribute('src');
                var dfdisY = _this.contain.innerHeight ? _this.contain.innerHeight : document.body.clientHeight;
                var disY = $(items[index]).offset().top;
                var sScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                // 判断这张图是否在可视区内
                if ((dfdisY + sScrollTop) >= disY && disY >= sScrollTop) {
                // 判断是img标签的图还是背景图
                    if (!src) return
                    if (src !== url) {
                        if (tag === 'img') {
                            thisItem[index].setAttribute('src', src);
                        } else {
                            var styles = thisItem[index].getAttribute('style') ? thisItem[index].getAttribute('style') + ';' : '';
                            thisItem[index].setAttribute('style', styles + 'background-image:url(' + src + ')');
                        }
                    }
                }
            });
        }
    };
    // 绑定事件
    _this.events.start();
    _this._addEvent(_this.contain, 'scroll', _this.events.start);
};

module.exports = LazyLoad



// WEBPACK FOOTER //
// ./src/lib/lazyload.js